import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectToolCollection } from "../../../actions";
import TextFieldList from "./TextFieldList";
import Dialog from "../../Dialog";
import "./TypeTools.css";
import localStorageWrapper from "../../../services/localStorageWrapper";

class TypeTools extends React.Component {
  state = {
    showDialog: false,
  };

  componentDidMount() {
    // Set 'Type' as the selected tool in the sidebar
    this.props.selectToolCollection({ activeTool: "Text" });

    // Expiration for local storage
    const now = Date.now(),
      expires = 60 * 60 * 1000 * 24;

    this.dialog = {
      title: "Designer's Tip",
      message:
        "Try pairing a script with a block font, use Transform Text Tools to create a cool effect.",
      topPosition: 55,
      leftPosition: 20,
      origin: "bottomleft",
    };

    if (
      !this.state.showDialog &&
      !localStorageWrapper.getItem("fypTypeDialogShown")
    ) {
      // Set local storage for 24 hours to remember that the tips have been shown
      localStorageWrapper.setItem("fypTypeDialogShown", true);
      localStorageWrapper.setItem("fypTypeDialogShownTimestamp", now);

      this.setState({
        showDialog: true,
      });
    }

    // Delete local storage after 24 hours
    if (
      now - localStorageWrapper.getItem("fypTypeDialogShownTimestamp") >
      expires
    ) {
      localStorageWrapper.removeItem("fypTypeDialogShown");
      localStorageWrapper.removeItem("fypTypeDialogShownTimestamp");
    }
  }

  handleHideDialog = () => {
    this.setState({
      showDialog: false,
    });
  };

  render() {
    return (
      <div className="tools-container tools-container--type">
        {this.state.showDialog && this.dialog && (
          <Dialog dialog={this.dialog} onHideDialog={this.handleHideDialog} />
        )}
        <TextFieldList />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  // Pass result of selectToolCollection to reducers
  return bindActionCreators(
    {
      selectToolCollection,
    },
    dispatch,
  );
}

export default connect(null, mapDispatchToProps)(TypeTools);
